import {withKnownRoute} from '../../lib/routes';
import {ItemsPage} from './items-page';

export default withKnownRoute(ItemsPage);
